"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroupContext = exports.ButtonGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const tools_1 = require("../../tools");
const Flex_1 = require("../Flex");
function ButtonGroup(props) {
    return (jsx_runtime_1.jsx(exports.ButtonGroupContext.Provider, Object.assign({ value: { inGroup: true } }, { children: jsx_runtime_1.jsx(StyledFlex, Object.assign({ boxShadow: 2, borderRadius: 3, fontSize: "sm", border: "1px solid rgba(125,125,125,0.2)" }, props), void 0) }), void 0));
}
exports.ButtonGroup = ButtonGroup;
exports.ButtonGroupContext = react_1.createContext({ inGroup: false });
const StyledFlex = tools_1.styled(Flex_1.Flex) `
  [data-ui-type='button'] {
    :not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 1px solid rgba(125, 125, 125, 0.2);
    }
    :not(:last-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;
//# sourceMappingURL=index.js.map